import { DateTime } from 'common/utils/date';
import $ from 'jquery';

$(function () {
  if (window.Localize) {
    DateTime.now().setLocale(window.Localize.getLanguage());
  } else {
    DateTime.now().setLocale('en');
  }

  $('.js-datepicker').datetimepicker({
    viewMode: 'days',
    format: 'L', // this is a format of bootstrap datetimepicker npm package which internally uses moment for formatting.
    locale: 'en-US', // only used in ExportsController - %m/%d/%Y required
  });
});
